import { apiCall } from '../actions/api-call';
import * as actions from '../actions/shipment-group';
import { Action } from '../actions';
import { Novel } from '../middlewares/novels';
import ShipmentGroupService from '../../ports/ShipmentGroupService';
import { InternalShipmentGroup, ShipmentGroupConfiguration } from '../../models/shipment-group';

export interface ShipmentGroupNovels {
  getInternalShipmentGroupsNovel: Novel<actions.GetInternalShipmentGroupsRequestAction, Action>;
  getShipmentGroupConfigurationsNovel: Novel<actions.GetShipmentGroupConfigurationsRequestAction, Action>;
  createShipmentGroupConfigurationNovel: Novel<actions.CreateShipmentGroupConfigurationRequestAction, Action>;
  updateShipmentGroupConfigurationNovel: Novel<actions.UpdateShipmentGroupConfigurationRequestAction, Action>;
  deleteShipmentGroupConfigurationNovel: Novel<actions.DeleteShipmentGroupConfigurationRequestAction, Action>;
}

export const shipmentGroupNovelsCreator = (
  shipmentGroupService: ShipmentGroupService,
): ShipmentGroupNovels => {
  const getInternalShipmentGroupsNovel = async (
    {}: actions.GetInternalShipmentGroupsRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    let internalShipmentGroups: InternalShipmentGroup[];
    try {
      dispatch(apiCall());
      internalShipmentGroups = await shipmentGroupService.getInternalShipmentGroups();
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(actions.getInternalShipmentGroups.failure(err.message));
      return;
    }
    dispatch(apiCall.success());
    dispatch(actions.getInternalShipmentGroups.success(internalShipmentGroups));
  };

  const getShipmentGroupConfigurationsNovel = async (
    {}: actions.GetShipmentGroupConfigurationsRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    let shipmentGroupConfigurations: ShipmentGroupConfiguration[];
    try {
      dispatch(apiCall());
      shipmentGroupConfigurations = await shipmentGroupService.getShipmentGroupConfigurations();
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(actions.getShipmentGroupConfigurations.failure(err.message));
      return;
    }
    dispatch(apiCall.success());
    dispatch(actions.getShipmentGroupConfigurations.success(shipmentGroupConfigurations));
  };

  const createShipmentGroupConfigurationNovel = async (
    { data }: actions.CreateShipmentGroupConfigurationRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    let shipmentGroupConfiguration: ShipmentGroupConfiguration;
    try {
      dispatch(apiCall());
      shipmentGroupConfiguration = await shipmentGroupService.createShipmentGroupConfiguration(data);
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(actions.createShipmentGroupConfiguration.failure(err.message));
      return;
    }
    dispatch(apiCall.success());
    dispatch(actions.createShipmentGroupConfiguration.success(shipmentGroupConfiguration));
  };

  const updateShipmentGroupConfigurationNovel = async (
    { data }: actions.UpdateShipmentGroupConfigurationRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    let shipmentGroupConfiguration: ShipmentGroupConfiguration;
    try {
      dispatch(apiCall());
      shipmentGroupConfiguration = await shipmentGroupService.updateShipmentGroupConfiguration(data);
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(actions.updateShipmentGroupConfiguration.failure(err.message));
      return;
    }
    dispatch(apiCall.success());
    dispatch(actions.updateShipmentGroupConfiguration.success(shipmentGroupConfiguration));
  };

  const deleteShipmentGroupConfigurationNovel = async (
    { data }: actions.DeleteShipmentGroupConfigurationRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      await shipmentGroupService.deleteShipmentGroupConfiguration(data);
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(actions.deleteShipmentGroupConfiguration.failure(err.message));
      return;
    }
    dispatch(apiCall.success());
    dispatch(actions.deleteShipmentGroupConfiguration.success(data.id));
  };

  return {
    getInternalShipmentGroupsNovel,
    getShipmentGroupConfigurationsNovel,
    createShipmentGroupConfigurationNovel,
    updateShipmentGroupConfigurationNovel,
    deleteShipmentGroupConfigurationNovel,
  };
};
